import { useContext } from "react";
import { ThemeContext } from "./ThemeProvider";
import defaultTheme from "./themes/default.json";

export const useAppTheme = () => {
  const theme = useContext(ThemeContext);
  return theme || defaultTheme;
};
